import React from "react";
import { ShieldCheck, Eye, Tag, Scale, XCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Eyebrow } from "../components/Bits";

const ICONS = [ShieldCheck, Eye, Tag, Scale];

export default function Trust() {
  const { t } = useLang();
  return (
    <div className="max-w-[1000px] mx-auto px-5 lg:px-8 py-16" data-testid="trust-page">
      <Eyebrow>{t("trust.eyebrow")}</Eyebrow>
      <h1 className="font-display text-4xl sm:text-5xl text-white mt-2">{t("trust.title")}</h1>
      <p className="text-white/70 mt-4 text-lg">{t("trust.sub")}</p>

      <div className="grid sm:grid-cols-2 gap-4 mt-10">
        {t("trust.principles").map((x, i) => {
          const Icon = ICONS[i] || ShieldCheck;
          return (
            <div key={x.h} className="glass rounded-2xl p-6">
              <div className="w-10 h-10 rounded-lg bg-gold/10 text-gold flex items-center justify-center"><Icon size={18} /></div>
              <div className="font-display text-lg text-white mt-3">{x.h}</div>
              <div className="text-white/55 text-sm mt-1">{x.p}</div>
            </div>
          );
        })}
      </div>

      <div className="glass rounded-2xl p-7 mt-8">
        <h2 className="font-display text-xl text-white mb-4">{t("trust.never_h")}</h2>
        <div className="flex flex-wrap gap-2">
          {t("trust.never").map((n) => (
            <span key={n} className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full bg-white/[0.03] border border-white/10 text-white/70">
              <XCircle size={13} className="text-red-400/80" /> {n}
            </span>
          ))}
        </div>
      </div>

      <p className="text-white/50 text-sm mt-8">{t("trust.close")}</p>
    </div>
  );
}
